import React from 'react';
import CottageList from '../components/CottageList';

const CottageListPage = () => {
  return (
    <div>
      <CottageList />
    </div>
  );
};

export default CottageListPage;
